var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page box_column"},[_c('Breadcrumb',{attrs:{"title":"企业信息","breadcrumb":_vm.breadcrumb}}),_c('edit-Item',{staticClass:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }